import React, { useState } from 'react'
import imageSpinner from '../../assets/image-spinner.gif'
import BasicPlaceholder from '../../assets/basic-placehoder.jpg'

const CustomImage = ({
  imageUrl,
  imgStyle = {},
  imgClass = '',
  imgAlt = 'placehoder',
  errorPlaceholder = BasicPlaceholder,
  loaderClass = '',
  loaderStyle = {},
  onClickRedirect = () => {},
}) => {
  const [imgLoaded, setImgLoaded] = useState(false)

  const imageStyle = !imgLoaded ? { display: 'none' } : { ...imgStyle }

  return (
    <>
      {!imgLoaded && (
        <div style={loaderStyle} className={`flex items-center justify-center ${loaderClass} `}>
          <img src={imageSpinner} alt="spinner" style={{ width: '2rem' }} />
        </div>
      )}
      <img
        src={imageUrl ? imageUrl : errorPlaceholder}
        style={imageStyle}
        className={imgClass}
        alt={imgAlt}
        onLoad={() => setImgLoaded(true)}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null // prevents looping
          currentTarget.src = errorPlaceholder
        }}
        onClick={onClickRedirect}
      />
    </>
  )
}

export default CustomImage
